module.exports = __webpack_public_path__ + "static/media/exchange-alt.38515605.svg";